import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import React from "react";
import { Box } from "@mui/material";
import BookingTopBar from "../../features/manageBookings/bookingTopBar";
import LoyaltyPointsTopBar from "../../features/manageLoyaltyPoints";
import LoyaltyPointsList from "../../features/manageLoyaltyPoints/loyaltyPointsList";
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageLoyaltyPoints = () => {
  const navigate = useNavigate();


  return (
    <MainContainer>
      <div className="main_title">
        <h1>Loyalty Points</h1>
        {/* <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage Booking Requests
        </p> */}
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}></Box>
        </div>
      </div>
      <div className="cards">
        <LoyaltyPointsTopBar />
        <LoyaltyPointsList/>
      </div>
    </MainContainer>
  );
};

export default ManageLoyaltyPoints;
